<template lang="pug">
div
  el-row
    div.aviso-erro(v-if="invalidos.length > 0")
      b.warning-titulo Atenção
      div.padding10
        p.warning {{invalidos[invalidos.length - 1]}}
  el-row.labelDiv(:gutter="20")
    el-col.container-input.inputDiv(:span="8")
      app-label.sub-titulo(
        label="Tipo de documento:"
        :required="getIsRequired"
      )
      el-select.input(
        @change="mudaTipo"
        class="select",
        v-model="tipoDocumentoSelecionado",
        placeholder="Selecione",
        value-key="codigo",
        name="tipoDocumento",
        clearable
        filterable
      )
        el-option(
          v-for="item in tiposDocumentosFiltrados",
          :key="item.codigo",
          :label="item.descricao",
          :value="item"
        )
    el-col.container-input(:span="16")
      app-label.sub-titulo(
        label="Anexar:"
        :required="getIsRequired"
      )
      div.upload-area(:id="id" :key="keyT+1")
        transition(name="idle-fade")
          div.content.content-idle(v-if="!loading && !success" :class="{'error-upload' : errors.length}")
            .info Arraste e solte ou clique para selecionar um arquivo.
            .format Formato(s) suportado(s): {{this.fileType.join(', ')}}
        transition(name="width-enter-active")
          el-row.content.content-loader(v-if="loading" :style="{width: (percentage < 20 ? 20 : percentage).toString() + '%'}")
            el-col.column(:span="12")
              div.arquivo-info
                div.name {{ fileName }}
                div.size {{ fileSize }} Kb
            transition(name="buttons-and-label-fade")
              el-col.column.right(v-if="success && percentage === 100")
                div.label.loadingSucess Carregado com sucesso!
        span.progress(v-if="!success && loading") {{ percentage }}%

      transition(name="buttons-and-label-fade")
        div.buttons.buttonsDuble(v-if="success")
          el-button(
            size="small"
            name="excluir"
            class="excluir"
            @click="excluir"
          )
            span.center
              i.fa.fa-times
              b &nbsp Remover
          el-button(
            size="small"
            name="anexar"
            class="anexar"
            @click="anexar"
            :disabled="!tipoDocumentoSelecionado"
            :title="!tipoDocumentoSelecionado ? 'Selecione o tipo de documento!' : ''"
          )
            span.center
              i.fal.fa-paperclip
              b &nbsp Anexar

      app-resumable(
        :key="keyT",
        :ref="id",
        :target="target",
        :fileType="fileType",
        :idDrop="id",
        :idInput="id",
        :fileTypeErrorCallback="fileTypeErrorCallback",
        :maxSize="maxSize || null"
        @onSuccess="onSuccessEvent",
        @onError="onErrorEvent",
        @onProgress="onProgressEvent",
        @fileAdded="onFileAddedEvent"
      )
</template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppResumable from '@/components/AppResumable'
import _ from 'lodash'
import AppLabel from '@/components/AppLabel'
import { v4 as uuidv4 } from 'uuid'
const { textoDocumentos } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default

export default {
  components: {
    AppResumable,
    AppLabel
  },

  mixins: [AppNotificacao],

  data () {
    return {
      keyT: 0,
      style: null,
      success: false,
      loading: false,
      percentage: 0,
      fileName: '',
      fileSize: '',
      filee: null,
      documentoSelecionado: null,
      tipoDocumentoSelecionado: null,
      invalidos: [],
      tipoPlanilha: '',
      mensagensTipoDocumento: {
        OUTROS: {
          texto: this.mensagemOutros ? this.mensagemOutros : textoDocumentos.OUTROS
        }
      },
      menssagemRetorno: ''
    }
  },
  props: {
    required: {
      type: Boolean,
      default: true
    },

    tiposDocumentos: {
      type: Array,
      required: true
    },

    id: {
      type: String,
      required: true
    },

    target: {
      type: String,
      required: true
    },

    fileType: {
      type: Array,
      required: true
    },

    onSuccess: {
      type: Function,
      required: false,
      default: () => {}
    },

    onFileAdded: {
      type: Function,
      required: false,
      default: () => {}
    },

    onError: {
      type: Function,
      required: false,
      default: () => {}
    },

    onProgress: {
      type: Function,
      required: false,
      default: () => {}
    },

    documento: {
      type: Object,
      required: false
    },

    maxSize: {
      type: Number,
      required: false
    },

    errors: {
      required: false,
      type: Array,
      default: () => []
    },

    aba: {
      type: String,
      required: false
    },

    documentos: {
      required: false,
      type: Array,
      default: () => []
    },
    mensagemOutros: {
      type: String,
      required: false
    }
  },

  mounted () {
    if (this.documento) {
      this.loading = true
      this.success = true
      this.fileName = this.documento.nomeOriginal
      this.fileSize = this.formatFileSize(this.documento.tamanho)
      this.percentage = 100
    }
  },

  computed: {
    // Joga a opção 'Outros' sempre para o fim de array
    tiposDocumentosFiltrados () {
      const array = [...this.tiposDocumentos]

      if (array.length) {
        const index = _.findIndex(
          array,
          item => item.codigo.indexOf('OUTROS') === 0
        )

        array.splice(array.length, 0, array.splice(index, 1)[0])
      }

      return array
    },

    getIsRequired () {
      if (
        this.$router.history.current.meta.routeGroup ===
        'CENTRAL_SOLICITAR_INFORMACOES'
      ) {
        return this.aba === 'Interessado'
      }
      return this.required
    },

    selecionartipoPlanilha () {
      return this.tipoDocumentoSelecionado?.codigo === 'TABELA_DADOS_CARTOGRAFICOS'
    }
  },

  methods: {
    mudaTipo (opcao) {
      this.keyT++
      this.$emit('mudaTipo', opcao)
    },
    formatFileSize (input) {
      return parseFloat((input / 1000).toFixed(2))
        .toLocaleString('pt-BR')
        .toString()
    },
    clear () {
      this.loading = false
      this.success = false
      this.fileName = ''
      this.fileSize = ''
      this.percentage = 0
      this.documentoSelecionado = null
      this.tipoDocumentoSelecionado = null
    },

    excluir () {
      this.clear()
    },

    async anexar () {
      const documento = Object.assign(this.documentoSelecionado, {
        ...this.documentoSelecionado,
        tipoDocumento: this.tipoDocumentoSelecionado
      })
      this.anexarDocumento(documento, this.invalidos)
      this.clear()
    },

    anexarDocumento (documento, invalidos) {
      this.$emit('anexar', documento, invalidos)
    },

    fileTypeErrorCallback () {
      this.showNotificacao(
        this.$messages.TIPO_WARNING,
        this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace(
          '$$',
          this.fileType.join(', ')
        )
      )
    },

    onSuccessEvent (value, fileKey) {
      this.success = true
      this.$props.onSuccess(this.$props.id, value, fileKey)
      this.documentoSelecionado = {
        id: this.notID() ? null : uuidv4(),
        fileName: value.fileName,
        fileSize: value.fileSize,
        fileKey
      }
    },

    notID () {
      //! Função usada no análise pra remover o id colocado no anexo
      const removeIdAnexo = [
        'documentoVistoria',
        'documentoFiscalizacao',
        'documentoGeorreferenciamento',
        'documentoPortaria',
        'documentoSpu',
        'documentoArquivoPublicacao',
        'documentoRelatorio',
        'documentoAdministrativo'
      ]
      return removeIdAnexo.includes(this.id)
    },

    onFileAddedEvent (file) {
      this.$refs[this.$props.id].uploadFile()
      this.loading = true
      this.fileName = file.file.name
      this.fileSize = this.formatFileSize(file.size)
      this.file = file
      this.$props.onFileAdded(this.$props.id, file)
    },

    onErrorEvent (message) {
      this.loading = false
      this.$props.onError(this.$props.id, message)
    },

    onProgressEvent (progress) {
      this.percentage = progress
      this.$props.onProgress(this.$props.id, progress)
    }
  },

  watch: {
    documento: {
      handler (val) {
        if (val && !val.removed) {
          this.loading = true
          this.success = true
          this.fileName = val.nomeOriginal
          this.fileSize = this.formatFileSize(val.tamanho)
          this.percentage = 100
        } else {
          this.clear()
        }
      },

      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.input {
  width: 100%;
}

.upload-area {
  width: 100%;
  cursor: pointer;
  background-color: rgba(51, 159, 96, 0.1);
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
}

.progress {
  align-self: center;
  color: $color-primary;
  padding: 0 10px;
}

.content {
  border-radius: 4px;
  width: 100%;
  height: 1rem;
  padding: 20px;
}

.content-idle {
  background-color: $border-color;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .info {
    color: $font-dark-color;
    font-size: 0.9rem;
  }
  .format {
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}

.content-loader {
  background-color: $color-primary;
  min-width: 50%;
}

.label,
.name {
  color: $white;
  font-size: 0.9rem;
}

.arquivo-info {
  position: absolute;
}

.column {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.buttons {
  margin-top: 1rem;
  float: right;
}

.right {
  align-items: flex-end;
}

.label {
  font-weight: bold;
}

.size {
  color: $border-color;
  font-size: 0.9rem;
}

.excluir {
  color: $error;
}

.excluir:hover {
  background-color: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}

.width-enter-active {
  transition: width 1s;
}

.width-enter {
  width: 20%;
}

.idle-fade-enter-active {
  transition: opacity 1s;
}

.idle-fade-enter {
  opacity: 0;
}

.buttons-and-label-fade-leave-active {
  transition: opacity 0.2s;
}

.buttons-and-label-fade-leave-to {
  opacity: 0;
}

.buttons-and-label-fade-enter-active {
  transition: opacity 3s;
}

.buttons-and-label-fade-enter {
  opacity: 0;
}

.error-upload {
  border: 1px solid $error;
  border-radius: 13px;
}

.colorText {
  color: #606266 !important;
}

.sub-titulo {
  margin-top: -20px;
  font-size: 14px;
  color: #606266 !important;
  font-weight: normal;
}

.tipo-documento {
  color: #606266 !important;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #f3f7fa;
  margin-bottom: 10px;
}

.warning-titulo {
  color: #e6a23c !important;
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}

.warning {
  color: #e6a23c !important;
}

.aviso-erro {
  padding: 8px 16px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  background-color: #fef6ea;
  border-radius: 4px;
  margin-top: 10px;
}

@media (max-width: 780px) {

  .content {
    padding: 7rem;
  }
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
    margin-bottom: 20px;
  }

  .column {
    flex-direction: row;
  }

  .buttonsDuble {
    display: flex;
    position: relative;
    left: 50px;
  }

  .loadingSucess {
    position: absolute;
    top: 50px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AppUploadDocumentos.vue